/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import $ from 'jquery'

class AddPayment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      Banks: [],
      id: 0,
      name: '',
      bank: '',
      type: ''
    }
  }
  componentDidMount() {
    if (!cookie.load('accessToken')) {
      window.location.assign('./')
    }
    this.getAllBanks()
  }

  getAllBanks = () => {
    http.get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_LIST_BANK}`, {}).then((res) => {
      if (res.data.error === null) {
        this.setState({
          Banks: res.data.object
        })
      } else {
        this.setState({
          Banks: []
        })
      }
    })
  }

  addPayment() {
    let name = this.state.name
    let bank = this.state.bank
    let type = this.state.type
    let id = this.state.id

    let nameError = false
    let typeError = false
    let bankError = false
    let idError = false
    let formError = false
    if (name == '') {
      formError = true
      nameError = true
      message.error('نام نوع پرداخت وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (bank == '') {
      formError = true
      bankError = true
      message.error('نام بانک را وارد کنید')
    } else {
      if (!bankError) {
        this.setState({
          error: ''
        })
      }
    }

    if (type == '') {
      formError = true
      typeError = true
      message.error('نوع را وارد کنید')
    } else {
      if (!typeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (id == 0) {
      formError = true
      idError = true
      message.error('بانک را وارد کنید')
    } else {
      if (!idError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        name: name,
        bank: bank,
        type: type,
        bank2: id
      }

      http
        .post(`${BASE_MANAGE.BASE_MANAGE_TYPE_ADD_PAYMENT}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('نوع پرداخت جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/Payment')
            }, 1000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  typeSelect = (e) => {
    let type = e.target.value
    this.setState({
      type
    })
  }

  bankSelect = (e) => {
    let id = e.target.value

    this.setState({
      id
    })
  }

  changeInputs = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    let {Banks} = this.state
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Payment'}>لیست نوع پرداخت</Link>
            </li>
            <li>ثبت نوع پرداخت</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت نوع پرداخت</p>
            </div>
            <div className="formComponent">
              <label>
                نام <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" name="name" className="form-control" onChange={this.changeInputs} />

              <label>
                نام بانک <span className="requireFiled">*</span>
              </label>
              <input type="text" id="bank" name="bank" className="form-control" onChange={this.changeInputs} />

              <label>
                نوع <span className="requireFiled">*</span>
              </label>
              <select id="type" className="form-control" onChange={this.typeSelect}>
                <option value="">-------</option>
                <option value="prepaid">پرداخت از قبل</option>
                <option value="cash">نقدی</option>
                <option value="card">کارتخوان</option>
              </select>
              <label>
                بانک <span className="requireFiled">*</span>
              </label>
              <select id="بانک" className="form-control" onChange={this.bankSelect}>
                <option>-------</option>

                {Banks.map((bank, index) => (
                  <option value={bank.id} key={index}>
                    {bank.name}
                  </option>
                ))}
              </select>

              <button className="btn btn-info btn-block" onClick={this.addPayment.bind(this)}>
                ثبت نوع پرداخت
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddPayment
